const generateMessage = async (code: number) => {
    // const code = parseInt(pcode, 10);
    // console.log(code, pcode, "codeee");

    switch (true) {
        case code === 503:
            return {
                title: 'Request Status',
                message: "Back-end server is at capacity"
            };
        case code === 504:
            return {
                title: 'Request Status',
                message: "No Internet Connection"
            };
        case code < 300:
            return {
                title: 'Request Status',
                message: "OK"
            };
        case code === 401:
            return {
                title: 'Error',
                message: "Invalid Session. Please re-login to continue!"
            };
        case code < 400:
            return {
                title: 'Error',
                message: "NOT AVAILABLE"
            };
        case code === 404:
            return {
                title: 'Error',
                message: "NOT FOUND"
            };
        case code === 409:
            return {
                title: 'Error',
                message: "DATA CONFLICT"
            };
        case code === 410:
            return {
                title: 'Response Status',
                message: "DELETED ITEM"
            };
        case code < 500:
            return {
                title: 'Error',
                message: "CLIENT ERROR"
            };

        default:
            return {
                title: 'Error',
                message: "SERVER ERROR"
            };
    }
};

export default generateMessage;